import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { getFetchAttributesRequestStatus } from '../selectors/RequestStatusSelector';
import { getCurrentUserDefaultHome } from '../selectors/AttributesSelector';
import { getHomePageOptions } from '../selectors/NavConfigSelector';
import { stageChange, clearChange } from '../actions/StagingActions';
import { DEFAULT_PAGE } from '../constants/StagingDataKeys';
import { anyRequestsFailed, anyRequestsPending } from '../utils/requestUtils';
import DefaultHomeEditor from '../components/DefaultHomeEditor';
import { tracker } from '../lib/tracker';
import { jsx as _jsx } from "react/jsx-runtime";
export class AccountOptionsContainer extends Component {
  render() {
    const {
      defaultHome,
      defaultHomeOptions,
      attributesFetchFailed,
      attributesFetchLoading,
      stagedDefaultHome
    } = this.props;
    const handleUpdateDefaultHome = value => {
      tracker.track('settings-usage', {
        action: 'change-default-homescreen',
        default: value
      });
      if (value !== this.props.defaultHome) {
        this.props.stageChange(DEFAULT_PAGE, value);
      } else {
        this.props.clearChange(DEFAULT_PAGE);
      }
    };

    // If there are no options and no default home, and the attributes are finished loading, return null
    if ((!defaultHomeOptions || defaultHomeOptions.length === 0) && !defaultHome && !attributesFetchLoading) {
      return null;
    }
    return /*#__PURE__*/_jsx(FormControl, {
      label: I18n.text('userPreferences.homePage.label'),
      tooltip: I18n.text('userPreferences.homePage.description'),
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsx(DefaultHomeEditor, {
        defaultHome: stagedDefaultHome || defaultHome,
        defaultHomeOptions: defaultHomeOptions,
        attributesFetchLoading: attributesFetchLoading,
        attributesFetchFailed: attributesFetchFailed,
        updateDefaultHome: handleUpdateDefaultHome
      })
    });
  }
}
AccountOptionsContainer.propTypes = {
  defaultHome: PropTypes.string,
  defaultHomeOptions: PropTypes.array,
  stageChange: PropTypes.func.isRequired,
  clearChange: PropTypes.func.isRequired,
  attributesFetchFailed: PropTypes.bool.isRequired,
  attributesFetchLoading: PropTypes.bool.isRequired,
  stagedDefaultHome: PropTypes.string
};
const mapStateToProps = state => {
  const fetchAttributesRequestStatus = getFetchAttributesRequestStatus(state);
  return {
    defaultHome: getCurrentUserDefaultHome(state),
    defaultHomeOptions: getHomePageOptions(state),
    attributesFetchFailed: anyRequestsFailed(fetchAttributesRequestStatus),
    attributesFetchLoading: anyRequestsPending(fetchAttributesRequestStatus),
    stagedDefaultHome: state.stagedChanges.get(DEFAULT_PAGE)
  };
};
export default connect(mapStateToProps, {
  stageChange,
  clearChange
})(AccountOptionsContainer);